const StyledTD = ({
  isSelected,
  disabled,
  children,
  ...rest
}: {
  isSelected?: boolean;
  disabled?: boolean;
  children?: React.ReactNode;
} & React.TdHTMLAttributes<HTMLTableCellElement>) => {
  return (
    <td
      className={`
        border-0 text-center font-medium text-base 
        leading-[2em] h-20 w-20 sm:h-[4.5em] sm:w-[4.5em]
      `}>
      <div
        className={`
          day-container 
          ${isSelected ? 'border-b-2 border-primary pb-2 text-darker-gray' : ''}
        `}>
        <div
          className={`
            day 
            ${disabled ? 'text-border cursor-not-allowed' : 'text-darker-gray cursor-pointer'}
          `}
          {...(!disabled && rest)}>
          {children}
        </div>
      </div>
    </td>
  );
};

export default StyledTD;
